module.exports = __webpack_public_path__ + "img/image-off-outline.3d4f12d2.svg";